export enum FrequencyType {
  SUBSCRIPTION_MONTHLY = 'SUBSCRIPTION_MONTHLY',
  SUBSCRIPTION_DAILY = 'SUBSCRIPTION_DAILY',
}
